import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { makeRequest } from '@crx-dev/hss-react-infrastructure';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Heading, Form, getFieldProps, Page, Label, Inputs } from '@crx-dev/hss-react-components';
import React, { useCallback } from 'react';
import { CreateManualReturnedRegisterRequest } from '../types/CreateManualReturnedRegisterRequest';
import { ReturnedRegisterSummary } from '../types/ReturnedRegisterSummary';

function CreateManualReturnedRegisterForm() {
    const history = useHistory();

    const mutation = useMutation<ReturnedRegisterSummary, unknown, CreateManualReturnedRegisterRequest>(item =>
        makeRequest({
            method: 'POST',
            path: '/api/V1/ReturnedDrugRegister/manual',
            data: item
        })
    );

    const formik = useFormik<CreateManualReturnedRegisterRequest>({
        initialValues: {
            className: '',
            strength: '',
            form: '',
            brandName: ''
        },
        validationSchema: yup.object().shape({
            className: yup.string().required('Required'),
            strength: yup.string().required('Required'),
            form: yup.string().required('Required')
        }),
        onSubmit: async values => {
            const registerSummary = await mutation.mutateAsync(values);
            history.push(`/returned-registers/${registerSummary.id}`);
        }
    });

    const onCancel = useCallback(() => {
        history.push('/returned-registers/add');
    }, []);

    return (
        <Page>
            <Page.Header title="Create Drug" onBackClick={onCancel} />
            <Page.Content>
                <Form onSubmit={formik.handleSubmit}>
                    <Form.Section>
                        <Heading>Drug Details</Heading>
                        <>
                            <Label htmlFor="className" label="Class" />
                            <Inputs.Text {...getFieldProps(formik, 'className')} />
                        </>
                        <>
                            <Label htmlFor="brandName" label="Brand Name" />
                            <Inputs.Text {...getFieldProps(formik, 'brandName')} />
                        </>
                        <>
                            <Label htmlFor="strength" label="Strength" />
                            <Inputs.Text {...getFieldProps(formik, 'strength')} />
                        </>
                        <>
                            <Label htmlFor="form" label="Form" />
                            <Inputs.Text {...getFieldProps(formik, 'form')} />
                        </>
                    </Form.Section>
                    <Form.Footer
                        onCancel={onCancel}
                        isSubmitting={mutation.isLoading}
                        submitError={mutation.isError}
                        submitButtonLabel="OK"
                    />
                </Form>
            </Page.Content>
        </Page>
    );
}

export default CreateManualReturnedRegisterForm;
